import storeManager from '../../store/StoreManager';

const visitedQuestionsReader = {
    /**
     * @param contentRevisionId id of question
     * @param state full state
     * @returns {boolean}
     */
    isQuestionVisited(contentRevisionId, state = storeManager.getState()) {
        return !!state.visitedQuestions[contentRevisionId];
    },
    /**
     * @returns {int}
     */
    getNumberOfVisitedQuestion() {
        const state = storeManager.getState();
        return Object.keys(state.visitedQuestions).length;
    },
};

export default visitedQuestionsReader;
